module.exports = __webpack_public_path__ + "media/images/instagram-btn-9bba806931aec2211a8d7222b0a57876.png";